import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=1ca51947&scoped=true&"
import script from "./Demo.vue?vue&type=script&lang=js&"
export * from "./Demo.vue?vue&type=script&lang=js&"
import style0 from "./Demo.vue?vue&type=style&index=0&id=1ca51947&prod&lang=scss&scoped=true&"
import style1 from "./Demo.vue?vue&type=style&index=1&id=1ca51947&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca51947",
  null
  
)

export default component.exports